let WebFont = require('webfontloader');

WebFont.load({
    google: {
        families: ['Roboto:300,400,500,700']
    }
});


// WEBPACK FOOTER //
// ./scripts/fonts.js